"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutation = void 0;
const react_1 = require("react");
const useMutation = (mutationFn, options = {}) => {
    const [state, setState] = (0, react_1.useState)('UNINITIALIZED');
    const [recentMutation, setRecentMutation] = (0, react_1.useState)(false);
    const [data, setData] = (0, react_1.useState)(null);
    const [error, setError] = (0, react_1.useState)(null);
    const reset = () => {
        setState('UNINITIALIZED');
        setRecentMutation(false);
        setError(null);
        setData(null);
    };
    const mutate = (...args) => __awaiter(void 0, void 0, void 0, function* () {
        setState('LOADING');
        setError(null);
        try {
            const data = yield mutationFn(...args);
            setData(data);
            setState('SUCCESS');
            if (options.onSuccess) {
                options.onSuccess(data, ...args);
            }
            setRecentMutation(true);
            setTimeout(() => {
                setRecentMutation(false);
            }, 2000);
        }
        catch (err) {
            setError(err);
            setState('ERROR');
            if (options.onError) {
                options.onError(err, ...args);
            }
        }
        finally {
            if (options.onSettled) {
                options.onSettled(...args);
            }
        }
    });
    return {
        isLoading: state === 'LOADING',
        isSuccess: state === 'SUCCESS',
        isInitialized: state !== 'UNINITIALIZED',
        isError: state === 'ERROR',
        status: state,
        recentMutation,
        data,
        error,
        reset,
        mutate,
    };
};
exports.useMutation = useMutation;
//# sourceMappingURL=hooks.js.map